<div class="rp-page">
  <div class="rp-container">

    <!-- Header: Logo + screen title -->
    <div class="rp-header">
      <img [src]="baseUri + '/assets/healthpicks-operator/images/logo.svg'" alt="Health Picks" class="rp-logo" />
      <h1 class="rp-screen-title">運用者画面</h1>
    </div>

    <!-- Card -->
    <div class="rp-card">

      <!-- AlertDialogHeader: title + description -->
      <div class="rp-dialog-header">
        <!-- Title row (flex justify-between with spacers to center title) -->
        <div class="rp-title-row">
          <div class="rp-icon-slot-32"></div>
          <h2 class="rp-card-title">パスワードの変更</h2>
          <div class="rp-icon-slot-24"></div>
        </div>
        <!-- Description -->
        <p class="rp-description">新しいパスワードを入力してください。</p>
      </div>

      <!-- Fields section (gap 16px between field groups) -->
      <div class="rp-fields">

        <!-- New password field group -->
        <div class="rp-field-group">
          <div class="rp-field-label">
            <span class="rp-label-text">新しいパスワード</span>
          </div>
          <!-- Input wrapper: border + radius matching Figma -->
          <div class="rp-input-wrapper" [class.rp-input-wrapper--focus]="false" [class.input-error]="errorMessages.password">
            <app-healthpicks-operator-password-input
              [(ngModel)]="password"
              name="password"
              placeholder="パスワード"
            ></app-healthpicks-operator-password-input>
          </div>
          <!-- Error message -->
          <app-healthpicks-operator-field-error [message]="errorMessages.password"></app-healthpicks-operator-field-error>
          <p class="rp-hint hint-password">半角の英小文字・英大文字・数字・記号（!@#$%^&*）のうち3種類以上を含む、8文字以上のパスワードを入力してください。</p>
        </div>

        <!-- Confirm password field group -->
        <div class="rp-field-group">
          <div class="rp-field-label">
            <span class="rp-label-text">新しいパスワード（確認）</span>
          </div>
          <!-- Input wrapper: border + radius matching Figma -->
          <div class="rp-input-wrapper" [class.input-error]="errorMessages.confirmPassword">
            <app-healthpicks-operator-password-input
              [(ngModel)]="confirmationPassword"
              name="confirm"
              placeholder="パスワード（再入力）"
            ></app-healthpicks-operator-password-input>
          </div>
          <!-- Error message -->
          <app-healthpicks-operator-field-error [message]="errorMessages.confirmPassword"></app-healthpicks-operator-field-error>
          <p class="rp-hint">パスワードを確認するために再入力してください</p>
        </div>

      </div>

      <!-- AlertDialogFooter: submit button centered -->
      <div class="rp-footer">
        <button
          type="button"
          class="rp-btn-primary"
          (click)="submitChangePassword()"
        >
          設定
        </button>
      </div>

    </div>

  </div>
</div>
